import cx from 'classnames';

type Props = {
    email: string,
    className?: string
} & React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export const EmailLink: React.FC<Props> = ({email, className, ...rest}: Props) =>
    <a {...rest} className={cx(className, 'tw-underline tw-text-dark')} href={`mailto: ${email}`}>{email}</a>;